module.exports = __webpack_public_path__ + "static/gbotolorun-b93246fb352128e1c5ac3de511e6ff5f.jpg";